import { FullScreenVideo } from "@components/fullScreenVideo";
import { Modal } from "@components/shared";
import ExperienceCard from "@components/spotprofile/experience-card";
import ExperiencesFilters, {
  type ExperiencesFilterOptions,
} from "@components/spotprofile/experiences-filters";
import SpotProfileLayout from "@layouts/SpotProfileLayout";
import Tab from "@components/spotprofile/tab";
import {
  getSpotCategories,
  getSpotInfo,
  getSpotTopExperiences,
} from "@lib/api";
import type {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from "next";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "@hooks/useTranslation";
import { events, track } from "@shared/tracking";

import type { Locale } from "../../../i18n-config";
import { MainLayout } from "@layouts/MainLayout";
import Head from "next/head";

import aboutusImg2 from "../../../public/images/aboutus/aboutus-icon2.svg";
import aboutusImg3 from "../../../public/images/aboutus/aboutus-icon3.svg";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Image from "next/image";

import { IoChevronDown } from "react-icons/io5";
import { pickByLocale } from "@lib/utils";

export default function TheAppPage({}) {
  const { t } = useTranslation();

  const router = useRouter();

  const locale = (router.locale ?? "en") as Locale;
  const description = pickByLocale(
    {
      en: "Book unique experiences in Barcelona, Marrakech, and Lisbon with beder. Discover the best activities and hotels through videos from other travelers. Press play, book, and enjoy the journey!",
      es: "Reserva experiencias únicas en Barcelona, Marrakech y Lisboa con beder. Descubre las mejores actividades y hoteles a través de vídeos de otros viajeros. ¡Dale al play, reserva y disfruta del viaje!",
      fr: "Réservez des expériences uniques à Barcelone, Marrakech et Lisbonne avec beder. Découvrez les meilleures activités et hôtels à travers des vidéos d’autres voyageurs. Appuyez sur play, réservez et profitez du voyage!",
    ru: "Бронируйте уникальные впечатления в Барселоне, Марракеше и Лиссабоне с beder. Открывайте лучшие развлечения и отели через видео от других путешественников. Нажмите «Play», забронируйте и наслаждайтесь путешествием!"
    },
    locale
  );

  return (
    <MainLayout isFooter={true} isBlack={true}>
      <Head>
        <title>Beder</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta httpEquiv="Content-Language" content="en,es,fr"></meta>
        <meta name="description" content={description} />
        <meta
          property="og:image"
          content="https://beder-sales.s3.eu-west-3.amazonaws.com/prod/styles/thumbnail/thumbnail.jpg"
          data-addsearch="no_crop"
        ></meta>
      </Head>
      <section className="relative flex flex-col items-center justify-center   pt-12 bg-white ">
        <h3 className="leading-[1.1] text-[40px] md:text-[50px] font-bold text-black text-center align-center ml-5 mr-5 justify-center content-center items-center mt-10">
          {locale == "es"
            ? "Política de Privacidad"
            : locale == "en"
            ? "Policy Privacy"
            : "Politique de Confidentialité"}
        </h3>
        <div>
          <IoChevronDown className="mt-3 " size={30} color="#00f3cd" />
        </div>
        {locale == "en" ? (
          <div className="mt-10 mx-10  w-[90%]">
            <p>
              From Travel Melon S.L. (BEDER) we are committed in defending the
              rights of personal data protection of our customers and contacts
              therefore we publish this information, in order to inform
              properly:
            </p>
            <br></br>
            <p>
              Of your rights and use of this website BEFORE providing the data;
            </p>
            <br></br>
            <p>
              Of the measures that guarantee the protection and integrity of the
              data;
            </p>
            <br></br>
            <p>
              So that the consent prior to the submission of data on your part
              may be duly substantiated
            </p>
            <br></br>
            <p>
              All this fulfilling with all the obligations legally provided in
              the Organic Law 15/1999, of December 13, of Data Protection
              (LOPD), in its Development Regulation 1720/2007, of December 21
              and in the European Regulation of Data Protection (RGPD), as well
              as all Spanish and European regulations applicable to this matter.
            </p>
            <br></br>
            <p>
              Therefore, any user who wants information, must necessarily mark
              the option, read and accepted the website’s privacy policy, the
              legal warning and the cookies policy.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              1. Who is responsible for the processing of your data?
            </h2>
            <br></br>
            <p>Corporate identity: Travel Melon S.L. (BEDER)</p>
            <br></br>
            <p>CIF: B02838506</p>
            <br></br>
            <p>
              Mailing address: Street la Llacuna, 162, 08018 Barcelona (SPAIN)
            </p>
            <br></br>
            <p>
              Email:{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>
            </p>
            <br></br>
            <p>Social Media:</p>
            <br></br>
            <ul>
              <li>
                • Instagram:{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.instagram.com/bederapp/"
                >
                  https://www.instagram.com/bederapp/
                </a>
              </li>
              <br></br>
              <li>
                • Tik-Tok:{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.tiktok.com/@bederapp"
                >
                  https://www.tiktok.com/@bederapp
                </a>
              </li>
              <br></br>
              <li>
                • Linkedin:{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.linkedin.com/company/bederapp"
                >
                  https://www.linkedin.com/company/bederapp
                </a>
              </li>
              <br></br>
            </ul>
            <br></br>
            <h2 className="text-[23px] font-bold">
              2. What personal data do we process and for what purpose?
            </h2>
            <br></br>
            <ul>
              <li>
                • Identifying data in the application (name, email, user,
                password). Its purpose is to identify you in the application and
                be a member of BEDER. The user and password are a basic security
                measure so that a third party does not usurp your identity in
                the application.
              </li>
              <br></br>
              <li>
                • Location data provided by the user of the application: The
                purpose is to better describe the trip you are doing and the
                places you visit, so that other members of the community can
                know or even take it as a possible route for future travels. You
                will be the one to tell us where you are, through the native
                location system of your device and it will link with the Google
                Maps application (
                <a
                  className="text-[#00f3cd]"
                  href="https://developers.google.com/terms"
                >
                  https://developers.google.com/terms
                </a>
                ) to locate your location or route whenever you want.
              </li>
              <br></br>
              <li>
                • Videos or images that users decide to share with the community
                that the user extracts from his mobile phone gallery.
              </li>
              <br></br>
              <li>
                • Videos or images from the web or videos or images from private
                locations that the user posts. The private capture is within the
                domestic sphere, so the personal data protection regulations do
                not apply, but the moment you share or disseminate third-party
                information or third-party material, you are responsible for
                having obtained the necessary permissions to do so beforehand.
              </li>
              <br></br>
              <li>
                • Comments and contributions that users can post on the
                application and that may involve personal data for the content
                they provide. In this case the purpose of this treatment is to
                manage their participation within BEDER’s community.
              </li>
              <br></br>
              <li>
                • Publication and sharing on social media (User, location). Any
                Tik-Tok or Instagram user outside of the BEDER community but who
                wants us to post or share certain images published on those
                platforms will only have to use our corporate hashtags or tag us
                in their posts. The purpose of this point lies in BEDER’s
                legitimate interest to get to know more members of the community
                and be able to share their activity based on the previous
                relationship established by the use of corporate hashtags and
                tags of our profile on social media.
              </li>
              <br></br>
              <li>
                • Optionally, you may request to receive periodic information
                related to the BEDER community via NEWSLETTER. In this case the
                purpose is to be able to maintain a continuous relationship with
                members, who have expressly ticked this option.
              </li>
              <br></br>
              <li>
                • Additionally we inform that BEDER will count on a data history
                (name, email, user). This is necessary to be able to have a
                history of the users which will allow for subsequent
                proceedings.
              </li>
              <br></br>
              <li>
                • Data that may indirectly provide information of a personal
                nature, derived from the activation of cookies and similar
                applications (IP addresses, browsing preferences, etc.).
              </li>
              <br></br>
            </ul>
            <p>
              <br></br>This personal information may be collected through the
              following platforms:
            </p>
            <br></br>
            <ul>
              <li>• BEDER App</li>
              <br></br>
              <li>
                • BEDER Web – Collection of data restricted to identifying data.
              </li>
              <br></br>
            </ul>
            <p>
              <br></br>Once collected, your data becomes part of a treatment to
              which the corresponding security measures are applied.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              3. How long will we keep your data?
            </h2>
            <br></br>
            <p>
              The personal data collected through the <strong>BEDER APP</strong>{" "}
              will be kept for the duration of time necessary to be able to
              carry out the procedure for which it was provided and for the
              fulfilment of legal obligations. Once the procedures are
              completed, the basic contact information will stay in BEDER
              database, to allow for subsequent proceedings. Once the
              relationship has finished they will be blocked only in order to
              comply with the possible legal obligations.
            </p>
            <br></br>
            <p>
              When you decide to unsubscribe as a user, your videos, albums and
              locations will be kept temporarily, in case you decide to use our
              application again. Therefore, we will keep this type of
              information for 90 days. Once this period has elapsed, we will
              proceed to delete it, keeping only the basic user data for
              historical purposes.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              4. What is the legitimacy for the treatment of your data?
            </h2>
            <br></br>
            <p>
              Legally we can treat the data we request from you once you´ve
              given us your consent to do so. This happens when you consent by
              expressly creating a profile in beder after having being informed
              of our Privacy Policy and our Terms and Conditions.
            </p>
            <br></br>
            <p>
              In general, in order to access our application, you must accept
              our terms of service, as well as having read our privacy policy,
              cookies and other related legal texts.
            </p>
            <br></br>
            <p>
              In the case of the archive and the sharing and publication of
              videos or images on social media. In the first scenario basis of
              this point lies in BEDER’s legitimate interest to provide a good
              service to users and manage the relationship with them, as well as
              guaranteeing the safety of users. For the second scenario, BEDER
              has legitimate interest in getting to know more members of the
              community and share their activity based on the previous
              relationship established by the use of corporate hashtags and tags
              of our profile on social media.
            </p>
            <br></br>
            <p>
              Finally, you allow us to make public those videos that you share
              in our app by expressly posting them.&nbsp;
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              5. Is your data communicated to other recipients?
            </h2>
            <br></br>
            <p>
              The data that you enter in the website will not be communicated to
              other entities, except for legal imperative or to be able to give
              fulfillment to the reason for which they were provided.
            </p>
            <br></br>
            <p>
              The BEDER app makes use of third-party tools, which make it
              possible to integrate the utilities and tools you can enjoy:
            </p>
            <br></br>
            <ul>
              <li>
                • Apple and Google Login through firebase
                <ul>
                  <li>
                    •{" "}
                    <a
                      className="text-[#00f3cd]"
                      href="https://www.apple.com/legal/"
                    >
                      https://www.apple.com/legal/
                    </a>
                  </li>
                  <br></br>
                  <li>
                    •{" "}
                    <a
                      className="text-[#00f3cd]"
                      href="https://firebase.google.com/support/privacy?hl=es-419"
                    >
                      https://firebase.google.com/support/privacy?hl=es-419
                    </a>
                  </li>
                  <br></br>
                </ul>
              </li>
              <br></br>
              <li>
                • Apis de Google{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://developers.google.com/terms"
                >
                  https://developers.google.com/terms
                </a>
              </li>
              <br></br>
              <li>
                • Amazon Web Services (AWS){" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://aws.amazon.com/en/privacy"
                >
                  https://aws.amazon.com/en/privacy
                </a>
              </li>
              <br></br>
              <li>
                • Server y dashboard deployment Heroku{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.heroku.com/policy/security"
                >
                  Heroku Security | Heroku
                </a>
              </li>
              <br></br>
              <li>• App deployment appcenter</li>
              <br></br>
              <li>• Base de datos MYSQL</li>
              <br></br>
            </ul>
            <p>
              Within our application you can activate different features such as
              the location, push notifications or access to your gallery upon
              personal selection. The data collected upon activation of these
              functions will be treated in the same way as the rest of the
              information collected via our forms.
            </p>
            <br></br>
            <p>
              Your data can be collected via forms on our website which are
              hosted on the AMAZON WEB SERVICES servers, located in the USA.
              This company despite being outside of the European Union is
              subject to the Privacy Shield to guarantee the protection of
              information. You can consult their privacy policy at:{" "}
              <a
                className="text-[#00f3cd]"
                href="https://aws.amazon.com/es/privacy/"
              >
                https://aws.amazon.com/es/privacy/
              </a>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              6. What rights do you have when you provide us with your
              information?
            </h2>
            <br></br>
            <p>
              <strong>
                Right of information<br></br>
              </strong>
              You have the right to be informed clearly BEFORE your data is
              collected about what data is being treated, with what purpose they
              are treated, where they have obtained the data and if they are
              going to communicate it or have communicated it to someone.
            </p>
            <br></br>
            <p>
              <strong>
                <br></br>Right of access<br></br>
              </strong>
              To know which of your data is being treated, for what purpose,
              where they have obtained the data and if they are going to
              communicate it or have communicated it to someone.
            </p>
            <br></br>
            <p>
              <strong>
                Right of rectification<br></br>
              </strong>
              To modify your inaccurate or incomplete data.
            </p>
            <br></br>
            <p>
              <strong>
                Right of deletion<br></br>
              </strong>
              to cancel/delete your inappropriate or excessive data
            </p>
            <br></br>
            <p>
              <strong>
                Right of cancellation<br></br>
              </strong>
              To cancel your inadequate or excessive data.
            </p>
            <br></br>
            <p>&nbsp;</p>
            <br></br>
            <p>
              <strong>Right of opposition</strong>
            </p>
            <br></br>
            <p>
              To prevent your data from being treated or to stop being treated,
              only in the cases established by law.
            </p>
            <br></br>
            <p>
              <strong>Right of treatment limitation</strong>
            </p>
            <br></br>
            <p>
              To request the non-use of data treatment in the cases established
              by law.
            </p>
            <br></br>
            <p>&nbsp;</p>
            <br></br>
            <p>
              <strong>Right to data portability</strong>
            </p>
            <br></br>
            <p>
              To be able to receive your data provided in a structured
              electronic format for normal use and in order to be able to
              transmit them to the person in charge.
            </p>
            <br></br>
            <p>&nbsp;</p>
            <br></br>
            <p>
              <strong>
                Right not to be the subject of individualized decisions
              </strong>
            </p>
            <br></br>
            <p>
              In order to not make a decision about you that produces legal
              effects or affects you based only on the treatment of your
              data.&nbsp;
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              7. How can you exercise your rights?
            </h2>
            <br></br>
            <p>
              To exercise any of your rights you must request it to the email{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>{" "}
              including:
            </p>
            <br></br>
            <p>
              1.- Photocopy of the ID Number (passport or other identity
              document) or electronic signature.
            </p>
            <br></br>
            <p>
              2.- Content of the request you make and, if necessary, the
              documents that prove it.
            </p>
            <br></br>
            <p>3.- Address (for notification purposes), date and signature</p>
            <br></br>
            <p>
              If you exercise your rights by a voluntarily appointed
              representative, you must provide the document or electronic
              instrument that proves the representation.
            </p>
            <br></br>
            <p>
              In the event that the owner of the data is a under-age or
              disabled, the rights will be exercised by their duly accredited
              legal representative.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              8. What can you do if your rights have not been catered?
            </h2>
            <br></br>
            <p>
              In case you consider that we have not satisfied your request, you
              can submit a claim to the Spanish Agency forData Protection in the
              section of its website:
              <a
                className="text-[#00f3cd]"
                href="https://sedeagpd.gob.es/sede-electronica-web/vistas/formReclamacionDerechos"
              >
                https://sedeagpd.gob.es/sede-electronica-web/vistas/formReclamacionDerechos
              </a>{" "}
              /reclamation.Rights.jsf&nbsp;
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              9. Links to other websites
            </h2>
            <br></br>
            <p>
              This privacy policy only applies to personal data collected
              through our website, but this website contains links to other
              websites so the Center is not responsible for the privacy
              practices of these other websites.
            </p>
            <br></br>
            <p>
              That is, when you click on one of these links you are leaving our
              website, so you should read the privacy policies of those other
              websites that collect personal data.
            </p>
            <br></br>
            <p>
              If you want more information, the Spanish Agency for Data
              Protection has published a citizen’s guide, you can access it at:
            </p>
            <br></br>
            <p>
              <a
                className="text-[#00f3cd]"
                href="http://www.agpd.es/portalwebAGPD/canaldocumentacion/publicaciones/common/Guias/GUIA_CIUDADANO.pdf"
              >
                http://www.agpd.es/portalwebAGPD/canaldocumentacion/publicaciones/common/Guias/GUIA_CIUDADANO.pdf
              </a>
              &nbsp;
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">10. Children’s Privacy</h2>
            <br></br>
            <p>
              <span className="" lang="EN-US">
                <span className="">
                  These Services do not address anyone under the age of 14. We
                  do not knowingly collect personally identifiable information
                  from children under 14 years of age. In the case we discover
                  that a child under 14 has provided us with personal
                  information, we immediately delete this from our servers. If
                  you are a parent or guardian and you are aware that your child
                  has provided us with personal information, please contact us
                  so that we will be able to do the necessary actions.
                </span>
              </span>
              <span className="" data-ccp-props='{"335551550":1,"335551620":1}'>
                &nbsp;
              </span>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">11. For Californian users</h2>
            <br></br>
            <p>
              The California Consumer Privacy Act (CCPA) requires us to disclose
              the categories of personal information we collect and how we use
              it, the categories of sources from which we collect personal
              information, and the third parties with whom we share it. We have
              disclosed this information throughout this document in Sections 2
              and below.
            </p>
            <br></br>
            <p>
              We must also communicate information about the rights California
              residents have under California law. You may exercise the
              following rights:
            </p>
            <br></br>
            <ul>
              <li>
                • Right to information and access. You can submit a verifiable
                request for information on:
              </li>
              <br></br>
            </ul>
            <ol>
              <li>
                • the categories of personal information we collect, use or
                share;
              </li>
              <br></br>
            </ol>
            <ul>
              <li>
                <ol>
                  <li>
                    • the purposes for which we collect or use categories of
                    personal information;
                  </li>
                  <br></br>
                  <li>
                    • the categories of sources from which we collect personal
                    information;
                  </li>
                  <br></br>
                  <li>
                    • specific pieces of personal information we have collected
                    about you.
                    <ul>
                      <li>
                        • Right to equal services. We will not discriminate
                        against you if you choose to exercise your privacy
                        rights.
                      </li>
                      <br></br>
                      <li>
                        • Right to delete. You can submit a verifiable request
                        to close your account, and we will delete your personal
                        information that we have collected.
                      </li>
                      <br></br>
                      <li>
                        • Right not to have your information traded: We do not
                        sell our users’ personal information.
                      </li>
                      <br></br>
                      <li>
                        • Possibility of exercising your rights yourself or
                        through a duly accredited person representing you.
                      </li>
                      <br></br>
                    </ul>
                  </li>
                  <br></br>
                </ol>
              </li>
              <br></br>
            </ul>
            <ul>
              <li>
                • The contact address through which you can exercise your rights
                is{" "}
                <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                  info@beder.app
                </a>
              </li>
              <br></br>
            </ul>
            <br></br>
            <h2 className="text-[23px] font-bold">
              12. Data Protection Policy that applies to citizens of Brazil
            </h2>
            <br></br>
            <ul>
              <li>
                •{" "}
                <p>
                  The LGPD (Lei Geral de Proteção de Dados) is Brazil’s federal
                  data protection law that regulates all types of personal data
                  processing in the country. It was passed in August 2018 and
                  entered into force in August 2020. The LGPD grants individuals
                  within Brazil nine enforceable rights over their own personal
                  data.
                </p>
                <br></br>
                <p>
                  They can be found in Article 18 and give individuals rights
                  to:
                </p>
                <br></br>
                <ol>
                  <li>
                    • Confirmation of the existence of the processing of your
                    data.
                  </li>
                  <br></br>
                  <li>• Access to your data</li>
                  <br></br>
                  <li>
                    • Correct incomplete, inaccurate or outdated information.
                  </li>
                  <br></br>
                  <li>
                    • Anonymise, block or delete unnecessary or excessive data
                    that is not being processed in accordance with the GDPR.
                  </li>
                  <br></br>
                  <li>
                    • Make your data portable, i.e. it can be provided to
                    another service or processor on request.
                  </li>
                  <br></br>
                  <li>• Have your data deleted.</li>
                  <br></br>
                  <li>
                    • Information on public or private entities with which the
                    controller has shared data.
                  </li>
                  <br></br>
                  <li>
                    • Information on the possibility of withholding consent and
                    consequences.
                  </li>
                  <br></br>
                  <li>• Withdraw consent</li>
                  <br></br>
                </ol>
                <p>
                  In addition, it establishes ten legal bases for processing
                  personal data, those which correspond to the data processing
                  carried out by beder and which are described in the previous
                  sections of this document are marked in bold:
                </p>
                <br></br>
                <ol>
                  <li>
                    {" "}
                    <strong>The consent of the data subject.</strong>
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    <strong>
                      For compliance with the controller’s legal or regulatory
                      obligation.
                    </strong>
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    For the implementation of public policies provided for in
                    laws or regulations, or based on contracts, agreements or
                    similar instruments.
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    For the performance of studies carried out by research
                    entities that guarantee, whenever possible, the
                    anonymisation of personal data.
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    <strong>
                      For the performance of a contract or preliminary
                      proceedings relating to the performance of a contract to
                      which the person concerned is a party.
                    </strong>
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    <strong>
                      For the exercise of rights in judicial, administrative or
                      arbitration proceedings (where it concerns the parties)
                    </strong>
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    For the protection of the life or physical safety of the
                    data subject or of a third party.
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    For the protection of health, in a procedure carried out by
                    health professionals or health institutions.
                  </li>
                  <br></br>
                  <li>
                    {" "}
                    <strong>
                      To serve the legitimate interests of the controller or a
                      third party, except where the fundamental rights and
                      freedoms of the data subject require that the protection
                      of his or her personal data takes precedence.
                    </strong>
                  </li>
                  <br></br>
                  <li> For credit protection</li>
                  <br></br>
                </ol>
                <p>&nbsp;</p>
                <br></br>
                <p>
                  In the case of consent, it shall be express and unambiguous,
                  being detailed.
                </p>
                <br></br>
                <p>
                  You can exercise your rights by sending an e-mail to{" "}
                  <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                    info@beder.app
                  </a>
                  &nbsp;
                </p>
                <br></br>
              </li>
              <br></br>
            </ul>
            <br></br>
            <h2 className="text-[23px] font-bold">
              13. Changes to This Privacy Policy
            </h2>
            <br></br>
            <p>
              <span>
                We may update our Privacy Policy from time to time. Thus, you
                are advised to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page.
              </span>
              <span data-ccp-props='{"335551550":1,"335551620":1}'>&nbsp;</span>
            </p>
            <br></br>
            <p>
              <span>This policy is effective as of </span>
              <span>2023-08-17</span>
              <span data-ccp-props='{"335551550":1,"335551620":1}'>&nbsp;</span>
            </p>
            <br></br>
          </div>
        ) : locale == "es" ? (
          <div className="mt-10 mx-10  w-[90%]">
            <br></br>
            <p>
              Desde Travel Melon S.L. (BEDER) estamos comprometidos en la
              defensa de los derechos de protección de datos personales de
              nuestros clientes y contactos por ello publicamos esta
              información, con el fin de informar adecuadamente:
            </p>
            <br></br>
            <p>
              De sus derechos y uso de este sitio web ANTES de facilitar los
              datos;
            </p>
            <br></br>
            <p>
              De las medidas que garanticen la protección e integridad de los
              datos;
            </p>
            <br></br>
            <p>
              Para que el consentimiento previo al envío de datos por su parte
              quede debidamente acreditado
            </p>
            <p>
              Todo ello cumpliendo con todas las obligaciones legalmente
              previstas en la Ley Orgánica 15/1999, de 13 de diciembre, de
              Protección de Datos (LOPD), en su Reglamento de Desarrollo
              1720/2007, de 21 de diciembre y en el Reglamento Europeo de
              Protección de Datos (RGPD) , así como toda la normativa española y
              europea aplicable en esta materia.
            </p>
            <br></br>
            <p>
              Por tanto, todo usuario que desee información, deberá marcar
              obligatoriamente la opción, leer y aceptar la política de
              privacidad del sitio web, el aviso legal y la política de cookies.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              1. ¿Quién es el responsable del tratamiento de sus datos?
            </h2>
            <br></br>
            <p>Identidad corporativa: Travel Melon SL (BEDER)</p>
            <p>CIF: B02838506</p>
            <p>
              Dirección postal: Carrer de la Llacuna, 162, 08018 Barcelona
              (ESPAÑA)
            </p>
            <br></br>
            <p>
              Correo electrónico:{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>
            </p>
            <br></br>
            <p>Medios de comunicación social:</p>
            <ul>
              <li>
                • Instagram:{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.instagram.com/bederapp/"
                >
                  https://www.instagram.com/bederapp/
                </a>
              </li>
              <br></br>{" "}
              <li>
                • Tik Tok:{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.tiktok.com/@bederapp"
                >
                  https://www.tiktok.com/@bederapp
                </a>
              </li>
              <br></br>{" "}
              <li>
                • Linkedin :
                <a
                  className="text-[#00f3cd]"
                  href="https://www.linkedin.com/company/bederapp"
                >
                  https://www.linkedin.com/company/bederapp
                </a>
              </li>
            </ul>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              2. ¿Qué datos personales tratamos y con qué finalidad?
            </h2>
            <br></br>
            <ul>
              <br></br>
              <li>
                • Datos identificativos en la aplicación (nombre, email,
                usuario, contraseña). Su finalidad es identificarte en la
                aplicación y ser miembro de BEDER. El usuario y la contraseña
                son una medida de seguridad básica para que un tercero no usurpe
                tu identidad en la aplicación.
              </li>
              <br></br>
              <li>
                • Datos de ubicación proporcionados por el usuario de la
                aplicación: La finalidad es describir mejor el viaje que está
                realizando y los lugares que visita, para que otros miembros de
                la comunidad puedan conocerlo o incluso tomarlo como posible
                ruta para futuros viajes. Serás tú quien nos diga dónde estás, a
                través del sistema de localización nativo de tu dispositivo y
                enlazará con la aplicación Google Maps (
                <a href="https://developers.google.com/terms">
                  https://developers.google.com/terms
                </a>
                ) para localizar tu ubicación o ruta cuando quieras.
              </li>
              <br></br>
              <li>
                • Vídeos o imágenes que los usuarios deciden compartir con la
                comunidad que el usuario extrae de la galería de su teléfono
                móvil.
              </li>
              <br></br>
              <li>
                • Vídeos o imágenes de la web o vídeos o imágenes de ubicaciones
                privadas que publica el usuario. La captación privada se
                encuentra dentro del ámbito doméstico, por lo que no se aplica
                la normativa de protección de datos personales, pero en el
                momento en que compartas o difundas información o material de
                terceros, eres responsable de haber obtenido previamente los
                permisos necesarios para hacerlo.
              </li>
              <br></br>
              <li>
                • Comentarios y aportaciones que los usuarios pueden publicar en
                la aplicación y que pueden implicar datos de carácter personal
                por el contenido que proporcionan. En este caso la finalidad de
                este tratamiento es gestionar su participación dentro de la
                comunidad de BEDER.
              </li>
              <br></br>
              <li>
                • Publicación y compartición en redes sociales (Usuario,
                ubicación). Cualquier usuario de Tik-Tok o Instagram fuera de la
                comunidad BEDER pero que quiera que publiquemos o compartamos
                ciertas imágenes publicadas en esas plataformas solo tendrá que
                usar nuestros hashtags corporativos o etiquetarnos en sus
                publicaciones. La finalidad de este punto radica en el interés
                legítimo de BEDER de conocer a más miembros de la comunidad y
                poder compartir su actividad en base a la relación previa que se
                establece mediante el uso de etiquetas y hashtags corporativos
                de nuestro perfil en las redes sociales.
              </li>
              <br></br>
              <br></br>
              <li>
                • Opcionalmente, puede solicitar recibir información periódica
                relacionada con la comunidad BEDER a través de NEWSLETTER. En
                este caso la finalidad es poder mantener una relación continua
                con los socios, que hayan marcado expresamente esta opción.
              </li>
              <br></br>
              <li>
                • Adicionalmente informamos que BEDER contará con un historial
                de datos (nombre, correo electrónico, usuario). Esto es
                necesario para poder tener un historial de los usuarios que
                permita realizar gestiones posteriores.
              </li>
              <br></br>
              <li>
                • Datos que indirectamente pueden proporcionar información de
                carácter personal, derivada de la activación de cookies y
                aplicaciones similares (direcciones IP, preferencias de
                navegación, etc.).
              </li>
            </ul>
            <p>
              Esta información personal podrá ser recabada a través de las
              siguientes plataformas:
            </p>
            <ul>
              <br></br>
              <li>• Aplicación BEDER</li>
              <br></br>
              <li>
                • BEDER Web – Recogida de datos restringida a datos
                identificativos.
              </li>
            </ul>
            <p>
              Una vez recabados, sus datos pasan a formar parte de un
              tratamiento al que se le aplican las medidas de seguridad
              correspondientes.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              3. ¿Cuánto tiempo conservaremos sus datos?
            </h2>
            <br></br>
            <p>
              Los datos personales recabados a través de la APP BEDER se
              conservarán durante el tiempo necesario para poder realizar el
              trámite para el que fueron facilitados y para el cumplimiento de
              las obligaciones legales. Una vez completados los trámites, la
              información básica de contacto permanecerá en la base de datos de
              BEDER, para permitir trámites posteriores. Una vez finalizada la
              relación serán bloqueados únicamente para el cumplimiento de las
              posibles obligaciones legales.
            </p>
            <p>
              Cuando decidas darte de baja como usuario, tus vídeos, álbumes y
              ubicaciones se mantendrán temporalmente, por si decides volver a
              utilizar nuestra aplicación. Por lo tanto, mantendremos este tipo
              de información durante 90 días. Una vez transcurrido este plazo,
              procederemos a su eliminación, conservando únicamente los datos
              básicos del usuario a efectos de histórico.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              4. ¿Cuál es la legitimación para el tratamiento de sus datos?
            </h2>
            <br></br>
            <p>
              Legalmente podemos tratar los datos que te solicitamos una vez que
              nos hayas dado tu consentimiento para ello. Esto sucede cuando
              usted da su consentimiento mediante la creación expresa de un
              perfil en beder después de haber sido informado de nuestra
              Política de Privacidad y nuestros Términos y Condiciones.
            </p>
            <p>
              Con carácter general, para poder acceder a nuestra aplicación
              deberás aceptar nuestras condiciones de servicio, así como haber
              leído nuestra política de privacidad, cookies y demás textos
              legales relacionados.
            </p>
            <p>
              En el caso del archivo y la compartición y publicación de videos o
              imágenes en redes sociales. En el primer supuesto base de este
              punto reside en el interés legítimo de BEDER de prestar un buen
              servicio a los usuarios y gestionar la relación con ellos, así
              como garantizar la seguridad de los usuarios. Para el segundo
              escenario, BEDER tiene interés legítimo en conocer a más miembros
              de la comunidad y compartir su actividad en base a la relación
              previa que se establece mediante el uso de etiquetas y hashtags
              corporativos de nuestro perfil en las redes sociales.
            </p>
            <p>
              Finalmente, nos permites hacer públicos aquellos videos que
              compartes en nuestra app al publicarlos expresamente.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              5. ¿Se comunican sus datos a otros destinatarios?
            </h2>
            <br></br>
            <p>
              Los datos que introduzcas en el sitio web no serán comunicados a
              otras entidades, salvo imperativo legal o para poder dar
              cumplimiento al motivo por el que fueron facilitados.
            </p>
            <p>
              La aplicación BEDER hace uso de herramientas de terceros, lo que
              permite integrar las utilidades y herramientas que puede
              disfrutar:
            </p>
            <ul>
              <br></br>
              <li>
                • Inicio de sesión de Apple y Google a través de firebase
                <ul>
                  <br></br>
                  <li>
                    •{" "}
                    <a
                      className="text-[#00f3cd]"
                      href="https://www.apple.com/legal/"
                    >
                      https://www.apple.com/legal/
                    </a>
                  </li>
                  <br></br>
                  <li>
                    •{" "}
                    <a href="https://firebase.google.com/support/privacy?hl=es-419">
                      https://firebase.google.com/support/privacy?hl=es-419
                    </a>
                  </li>
                </ul>
              </li>
              <br></br>
              <li>
                • API de Google
                <a
                  className="text-[#00f3cd]"
                  href="https://developers.google.com/terms"
                >
                  https://developers.google.com/terms
                </a>
              </li>
              <br></br>
              <li>
                • Servicios web de Amazon (AWS){" "}
                <a href="https://aws.amazon.com/en/privacy">
                  https://aws.amazon.com/en/privacy
                </a>
              </li>
              <br></br>
              <li>
                • Implementación de servidor y tablero Heroku
                <a href="https://www.heroku.com/policy/security">
                  Seguridad Heroku | Heroku
                </a>
              </li>
              <br></br>
              <li>
                • centro de aplicaciones de implementación de aplicaciones
              </li>
              <br></br>
              <li>• Base de datos MYSQL</li>
            </ul>
            <p>
              Dentro de nuestra aplicación, puede activar diferentes funciones,
              como la ubicación, las notificaciones automáticas o el acceso a su
              galería mediante una selección personal. Los datos recabados al
              activar estas funciones serán tratados del mismo modo que el resto
              de información recabada a través de nuestros formularios.
            </p>
            <p>
              Sus datos se pueden recopilar a través de formularios en nuestro
              sitio web que se encuentran alojados en los servidores de AMAZON
              WEB SERVICES, ubicados en los EE. UU. Esta empresa a pesar de
              estar fuera de la Unión Europea está sujeta al Privacy Shield para
              garantizar la protección de la información. Puedes consultar su
              política de privacidad en:
              <a href="https://aws.amazon.com/es/privacy/">
                https://aws.amazon.com/es/privacy/
              </a>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              6. ¿Qué derechos tienes cuando nos facilitas tus datos?
            </h2>
            <br></br>
            <p>
              <strong>
                Derecho de información<br></br>
              </strong>
              Tiene derecho a que se le informe claramente ANTES de la recogida
              de sus datos sobre qué datos se están tratando, con qué finalidad
              se tratan, de dónde han obtenido los datos y si los van a
              comunicar o se los han comunicado a alguien.
            </p>
            <br></br>
            <p>
              <strong>
                Derecho de acceso<br></br>
              </strong>
              Saber cuáles de sus datos están siendo tratados, con qué
              finalidad, de dónde han obtenido los datos y si los van a
              comunicar o se los han comunicado a alguien.
            </p>
            <p>
              <strong>
                Derecho de rectificación<br></br>
              </strong>
              Modificar sus datos inexactos o incompletos.
            </p>
            <p>
              <strong>
                Derecho de supresión
                <br></br> <br></br>
              </strong>
              para cancelar/eliminar sus datos inapropiados o excesivos
            </p>
            <p>
              <strong>
                Derecho de cancelación<br></br>
              </strong>
              Para cancelar sus datos inadecuados o excesivos.
            </p>
            <p>
              <strong>
                Derecho de oposición<br></br>
              </strong>
              A impedir que se traten sus datos o dejar de tratarlos, únicamente
              en los supuestos legalmente establecidos.
            </p>
            <p>
              <strong>
                Derecho de limitación del tratamiento<br></br>
              </strong>
              A solicitar la no utilización del tratamiento de datos en los
              casos establecidos por la ley.
            </p>
            <p>
              <strong>
                Derecho a la portabilidad de los datos
                <br></br> <br></br>
              </strong>
              Para poder recibir sus datos facilitados en un formato electrónico
              estructurado para su uso habitual y para poder transmitirlos al
              responsable.
            </p>
            <p>
              <strong>
                Derecho a no ser objeto de decisiones individualizadas<br></br>
              </strong>
              Con la finalidad de no tomar una decisión sobre usted que produzca
              efectos jurídicos o le afecte con base únicamente en el
              tratamiento de sus datos.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              7. ¿Cómo puede ejercer sus derechos?
            </h2>
            <br></br>
            <p>
              Para ejercer cualquiera de sus derechos deberá solicitarlo al
              correo electrónico
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>
              incluido:
            </p>
            <p>
              1.- Fotocopia del Número de DNI (pasaporte u otro documento de
              identidad) o firma electrónica.
            </p>
            <p>
              2.- Contenido de la solicitud que formula y, en su caso, de los
              documentos que lo acrediten.
            </p>
            <p>3.- Domicilio (a efectos de notificaciones), fecha y firma</p>
            <p>
              Si ejerce sus derechos por un representante designado
              voluntariamente, deberá aportar el documento o instrumento
              electrónico que acredite la representación.
            </p>
            <p>
              En caso de que el titular de los datos sea menor de edad o
              incapacitado, los derechos serán ejercitados por su representante
              legal debidamente acreditado.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              8. ¿Qué puedes hacer si tus derechos no han sido atendidos?
            </h2>
            <br></br>
            <p>
              En caso de que considere que no hemos satisfecho su solicitud,
              puede presentar una reclamación ante la Agencia Española de
              Protección de Datos en el apartado de su web:{" "}
              <a href="https://sedeagpd.gob.es/sede-electronica-web/vistas/formReclamacionDerechos">
                https://sedeagpd.gob.es/sede-electronica-web/vistas/formReclamacionDerechos
              </a>
              /reclamación.Derechos.jsf
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              9. Enlaces a otros sitios web
            </h2>
            <br></br>
            <p>
              Esta política de privacidad solo se aplica a los datos personales
              recopilados a través de nuestro sitio web, pero este sitio web
              contiene enlaces a otros sitios web, por lo que el Centro no es
              responsable de las prácticas de privacidad de estos otros sitios
              web.
            </p>
            <p>
              Es decir, cuando hace clic en uno de estos enlaces está saliendo
              de nuestro sitio web, por lo que debe leer las políticas de
              privacidad de esos otros sitios web que recopilan datos
              personales.
            </p>
            <p>
              Si quieres más información, la Agencia Española de Protección de
              Datos ha editado una guía del ciudadano, puedes acceder a ella en:
            </p>
            <p>
              <a
                className="text-[#00f3cd]"
                href="http://www.agpd.es/portalwebAGPD/canaldocumentacion/publicaciones/common/Guias/GUIA_CIUDADANO.pdf"
              >
                http://www.agpd.es/portalwebAGPD/canaldocumentacion/publicaciones/common/Guias/GUIA_CIUDADANO.pdf
              </a>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">10. Privacidad de menores</h2>
            <br></br>
            <p>
              <span>
                <span>Estos</span> <span>Servicios</span>
                <span> no </span>
                <span>están</span> <span>dirigidos</span>
                <span> a </span>
                <span>nadie</span> <span>menor</span>
                <span> de 14 </span>
                <span>años</span>
                <span>. No </span>
                <span>recogemos</span> <span>intencionadamente</span>{" "}
                <span>datos</span> <span>personales</span>
                <span> de </span>
                <span>niños</span> <span>menores</span>
                <span> de 14 </span>
                <span>años</span>
                <span>. En </span>
                <span>el</span> <span>caso</span>
                <span> de </span>
                <span>descubrir</span>
                <span> que un </span>
                <span>menor</span>
                <span> de 14 </span>
                <span>años</span> <span>nos</span>
                <span> ha </span>
                <span>proporcionado</span> <span>información</span>
                <span> personal, la </span>
                <span>eliminamos</span> <span>inmediatamente</span>
                <span> de </span>
                <span>nuestros</span> <span>servidores</span>
                <span>. Si </span>
                <span>eres</span>
                <span> padre, </span>
                <span>madre</span>
                <span> o tutor/a legal y </span>
                <span>estás</span> <span>en</span> <span>conocimiento</span>
                <span> de que </span>
                <span>tu</span> <span>hijo</span>
                <span>/a </span>
                <span>nos</span>
                <span> ha </span>
                <span>proporcionado</span> <span>información</span>
                <span> personal, </span>
                <span>por</span>
                <span> favor, </span>
                <span>ponte</span> <span>en</span> <span>contacto</span>
                <span> con </span>
                <span>nosotros</span>
                <span> para que </span>
                <span>podamos</span> <span>proceder</span>
                <span> a </span>
                <span>tomar</span>
                <span> las </span>
                <span>medidas</span> <span>necesarias</span>
                <span>.</span>
              </span>
              <span>&nbsp;</span>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              11. Para usuarios de California
            </h2>
            <br></br>
            <p>
              La Ley de Privacidad del Consumidor de California (CCPA) nos exige
              divulgar las categorías de información personal que recopilamos y
              cómo la usamos, las categorías de fuentes de las que recopilamos
              información personal y los terceros con quienes la compartimos.
              Hemos divulgado esta información a lo largo de este documento en
              las Secciones 2 y siguientes.
            </p>
            <p>
              También debemos comunicar información sobre los derechos que
              tienen los residentes de California según la ley de California.
              Podrá ejercer los siguientes derechos:
            </p>
            <ul>
              <br></br>
              <li>
                • Derecho a la información y acceso. Puede enviar una solicitud
                verificable de información sobre:
              </li>
            </ul>
            <ol>
              <br></br>
              <li>
                • las categorías de información personal que recopilamos, usamos
                o compartimos;
              </li>
            </ol>
            <ul>
              <br></br>
              <li>
                {" "}
                <ol>
                  <br></br>
                  <li>
                    • los fines para los que recopilamos o utilizamos categorías
                    de información personal;
                  </li>
                  <br></br>
                  <li>
                    • las categorías de fuentes de las que recopilamos
                    información personal;
                  </li>
                  <br></br>
                  <li>
                    • piezas específicas de información personal que hemos
                    recopilado sobre usted.
                    <ul>
                      <br></br>
                      <li>
                        • Derecho a la igualdad de servicios. No lo
                        discriminaremos si elige ejercer sus derechos de
                        privacidad.
                      </li>
                      <br></br>
                      <li>
                        • Derecho a borrar. Puede enviar una solicitud
                        verificable para cerrar su cuenta y eliminaremos la
                        información personal que hayamos recopilado.
                      </li>
                      <br></br>
                      <li>
                        • Derecho a que no se comercialice su información: No
                        vendemos la información personal de nuestros usuarios.
                      </li>
                      <br></br>
                      <li>
                        • Posibilidad de ejercer sus derechos por sí mismo o a
                        través de persona debidamente acreditada que le
                        represente.
                      </li>
                    </ul>
                  </li>
                </ol>
              </li>
            </ul>
            <ul>
              <br></br>
              <li>
                • La dirección de contacto a través de la cual podrá ejercer sus
                derechos es{" "}
                <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                  info@beder.app
                </a>
              </li>
            </ul>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              12. Política de Protección de Datos que se aplica a los ciudadanos
              de Brasil
            </h2>
            <br></br>
            <p>
              La LGPD (Lei Geral de Proteção de Dados) es la ley federal de
              protección de datos de Brasil que regula todos los tipos de
              procesamiento de datos personales en el país. Fue aprobada en
              agosto de 2018 y entró en vigor en agosto de 2020. La LGPD otorga
              a las personas dentro de Brasil nueve derechos exigibles sobre sus
              propios datos personales.
            </p>
            <p>
              Se pueden encontrar en el Artículo 18 y otorgan a las personas
              derechos a:
            </p>
            <ol>
              <br></br>
              <li>
                • Confirmación de la existencia del tratamiento de sus datos.
              </li>
              <br></br>
              <li>• Accede a tus datos</li>
              <br></br>
              <li>
                • Corregir información incompleta, inexacta o desactualizada.
              </li>
              <br></br>
              <li>
                • Anonimizar, bloquear o eliminar datos innecesarios o excesivos
                que no se estén procesando de acuerdo con el RGPD.
              </li>
              <br></br>
              <li>
                • Haga que sus datos sean portátiles, es decir, se pueden
                proporcionar a otro servicio o procesador a pedido.
              </li>
              <br></br>
              <li>• Que se eliminen tus datos.</li>
              <br></br>
              <li>
                • Información sobre entidades públicas o privadas con las que el
                responsable del tratamiento haya compartido datos.
              </li>
              <br></br>
              <li>
                • Información sobre la posibilidad de negar el consentimiento y
                consecuencias.
              </li>
              <br></br>
              <li>• Retirar el consentimiento</li>
            </ol>
            <p>
              Además, establece diez bases legales para el tratamiento de datos
              personales, se destacan en negrita las que corresponden al
              tratamiento de datos que realiza beder y que se describen en los
              apartados anteriores de este documento:
            </p>
            <ol>
              <br></br>
              <li>
                • <strong>El consentimiento del interesado.</strong>
              </li>
              <br></br>
              <li>
                •{" "}
                <strong>
                  Para el cumplimiento de la obligación legal o reglamentaria
                  del responsable del tratamiento.
                </strong>
              </li>
              <br></br>
              <li>
                • Para la ejecución de políticas públicas previstas en leyes o
                reglamentos, o con base en contratos, convenios o instrumentos
                similares.
              </li>
              <br></br>
              <li>
                • Para la realización de estudios realizados por entidades de
                investigación que garanticen, siempre que sea posible, la
                anonimización de los datos personales.
              </li>
              <br></br>
              <br></br>
              <li>
                •{" "}
                <strong>
                  Para la ejecución de un contrato o diligencias previas
                  relativas a la ejecución de un contrato en el que el
                  interesado sea parte.
                </strong>
              </li>
              <br></br>
              <br></br>
              <li>
                •{" "}
                <strong>
                  Para el ejercicio de derechos en procedimientos judiciales,
                  administrativos o arbitrales (cuando se trate de las partes)
                </strong>
              </li>
              <br></br>
              <li>
                • Para la protección de la vida o la integridad física del
                interesado o de un tercero.
              </li>
              <br></br>
              <li>
                • Para la protección de la salud, en un procedimiento realizado
                por profesionales de la salud o instituciones de salud.
              </li>
              <br></br>
              <li>
                •{" "}
                <strong>
                  Para atender los intereses legítimos del responsable del
                  tratamiento o de un tercero, salvo que los derechos y
                  libertades fundamentales del interesado exijan que prevalezca
                  la protección de sus datos personales.
                </strong>
              </li>
              <li>• Para protección de crédito</li>
            </ol>
            <p>&nbsp;</p>
            <p>
              En el caso del consentimiento, éste deberá ser expreso e
              inequívoco, siendo detallado.
            </p>
            <p>
              Puede ejercer sus derechos enviando un correo electrónico a{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              13. Cambios en la presente Política de Privacidad{" "}
            </h2>
            <br></br>
            <p>
              <span>
                Es posible que actualicemos nuestra Política de Privacidad
                ocasionalmente. Por consiguiente, te recomendamos revisar esta
                página de manera periódica en caso de cualquier cambio. Serás
                notificado/a de cualquier cambio mediante la publicación de la
                nueva Política de Privacidad en esta misma página.
              </span>
              <span>&nbsp;</span>
            </p>
            <p>
              <span>Esta política es efectiva a partir de </span>2023-08-17.
            </p>
          </div>
        ) : (
          <div className="mt-10 mx-10 ">
            <p>
              De la part de Travel Melon S.L. (BEDER), nous nous engageons à
              défendre les droits de protection des données personnelles de nos
              clients et contacts, c'est pourquoi nous publions ces informations
              afin d'informer correctement :
            </p>
            <br></br>
            <p>
              De vos droits et de l'utilisation de ce site Web AVANT de fournir
              les données ;
            </p>
            <br></br>
            <p>
              Des mesures garantissant la protection et l'intégrité des données
              ;
            </p>
            <br></br>
            <p>
              Afin que le consentement préalable à la soumission des données de
              votre part puisse être dûment justifié.
            </p>
            <br></br>
            <p>
              Tout cela en respectant toutes les obligations prévues légalement
              dans la Loi organique 15/1999, du 13 décembre, sur la protection
              des données (LOPD), dans son Règlement de développement 1720/2007,
              du 21 décembre, et dans le Règlement européen sur la protection
              des données (RGPD), ainsi que toutes les réglementations
              espagnoles et européennes applicables en la matière.
            </p>
            <br></br>
            <p>
              Par conséquent, tout utilisateur souhaitant des informations doit
              nécessairement cocher l'option, lire et accepter la politique de
              confidentialité du site Web, l'avertissement légal et la politique
              en matière de cookies.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              1. Qui est responsable du traitement de vos données ?
            </h2>
            <br></br>
            <p>Identité de l'entreprise : Travel Melon S.L. (BEDER)</p>
            <br></br>
            <p>CIF : B02838506</p>
            <br></br>
            <p>
              Adresse postale : Rue la Llacuna, 162, 08018 Barcelone (ESPAGNE)
            </p>
            <br></br>
            <p>
              Email :{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>
            </p>
            <br></br>
            <p>Réseaux sociaux :</p>
            <br></br>
            <ul>
              <li>
                • Instagram :{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.instagram.com/bederapp/"
                >
                  https://www.instagram.com/bederapp/
                </a>
              </li>
              <br></br>
              <li>
                • Tik-Tok :{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.tiktok.com/@bederapp"
                >
                  https://www.tiktok.com/@bederapp
                </a>
              </li>
              <br></br>
              <li>
                • Linkedin :{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.linkedin.com/company/bederapp"
                >
                  https://www.linkedin.com/company/bederapp
                </a>
              </li>
              <br></br>
            </ul>
            <br></br>
            <h2 className="text-[23px] font-bold">
              2. Quelles données personnelles traitons-nous et dans quel but ?
            </h2>
            <br></br>
            <ul>
              <li>
                • Données d'identification dans l'application (nom, email,
                utilisateur, mot de passe). Son but est de vous identifier dans
                l'application et d'être membre de BEDER. L'utilisateur et le mot
                de passe sont une mesure de sécurité de base pour qu'une tierce
                partie n'usurpe pas votre identité dans l'application.
              </li>
              <br></br>
              <li>
                • Données de localisation fournies par l'utilisateur de
                l'application : Le but est de mieux décrire le voyage que vous
                faites et les endroits que vous visitez, afin que les autres
                membres de la communauté puissent le savoir ou même le prendre
                comme un itinéraire possible pour des voyages futurs. Vous serez
                celui qui nous indiquera où vous êtes, grâce au système de
                localisation natif de votre appareil, et cela sera lié à
                l'application Google Maps (
                <a
                  className="text-[#00f3cd]"
                  href="https://developers.google.com/terms"
                >
                  https://developers.google.com/terms
                </a>
                ) pour localiser votre position ou votre itinéraire à tout
                moment.
              </li>
              <br></br>
              <li>
                • Vidéos ou images que les utilisateurs décident de partager
                avec la communauté à partir de la galerie de leur téléphone
                portable.
              </li>
              <br></br>
              <li>
                • Vidéos ou images du web ou vidéos ou images d'emplacements
                privés que l'utilisateur publie. La capture privée est dans la
                sphère domestique, donc les réglementations sur la protection
                des données personnelles ne s'appliquent pas, mais dès que vous
                partagez ou diffusez des informations ou du matériel appartenant
                à des tiers, vous êtes responsable d'avoir obtenu au préalable
                les autorisations nécessaires pour le faire.
              </li>
              <br></br>
              <li>
                • Commentaires et contributions que les utilisateurs peuvent
                poster sur l'application et qui peuvent impliquer des données
                personnelles pour le contenu qu'ils fournissent. Dans ce cas, le
                but de ce traitement est de gérer leur participation au sein de
                la communauté BEDER.
              </li>
              <br></br>
              <li>
                • Publication et partage sur les médias sociaux (utilisateur,
                emplacement). Tout utilisateur Tik-Tok ou Instagram en dehors de
                la communauté BEDER mais qui souhaite que nous publiions ou
                partagions certaines images publiées sur ces plateformes n'aura
                qu'à utiliser nos hashtags d'entreprise ou nous mentionner dans
                leurs publications. Le but de ce point réside dans l'intérêt
                légitime de BEDER à connaître davantage de membres de la
                communauté et à pouvoir partager leur activité sur la base de la
                relation précédente établie par l'utilisation des hashtags
                d'entreprise et des mentions de notre profil sur les médias
                sociaux.
              </li>
              <br></br>
              <li>
                • Facultativement, vous pouvez demander à recevoir
                périodiquement des informations liées à la communauté BEDER via
                la NEWSLETTER. Dans ce cas, le but est de pouvoir maintenir une
                relation continue avec les membres qui ont expressément coché
                cette option.
              </li>
              <br></br>
              <li>
                • Nous vous informons également que BEDER disposera d'un
                historique des données (nom, email, utilisateur). Ceci est
                nécessaire pour pouvoir disposer d'un historique des
                utilisateurs qui permettra des démarches ultérieures.
              </li>
              <br></br>
              <li>
                • Données pouvant fournir indirectement des informations à
                caractère personnel, dérivées de l'activation de cookies et
                d'applications similaires (adresses IP, préférences de
                navigation, etc.).
              </li>
              <br></br>
            </ul>
            <p>
              <br></br>Ces informations personnelles peuvent être collectées via
              les plateformes suivantes :
            </p>
            <br></br>
            <ul>
              <li>• Application BEDER</li>
              <br></br>
              <li>
                • Site Web BEDER – Collecte de données restreinte aux données
                d'identification.
              </li>
              <br></br>
            </ul>
            <p>
              <br></br>Une fois collectées, vos données font partie d'un
              traitement auquel les mesures de sécurité correspondantes sont
              appliquées.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              3. Pendant combien de temps conserverons-nous vos données ?
            </h2>
            <br></br>
            <p>
              Les données personnelles collectées via l'{" "}
              <strong>APPLICATION BEDER</strong> seront conservées pendant la
              durée nécessaire à la réalisation de la procédure pour laquelle
              elles ont été fournies et pour l'exécution des obligations
              légales. Une fois les procédures terminées, les informations de
              contact de base resteront dans la base de données de BEDER, afin
              de permettre des démarches ultérieures. Une fois la relation
              terminée, elles seront bloquées uniquement afin de se conformer
              aux éventuelles obligations légales.
            </p>
            <br></br>
            <p>
              Lorsque vous décidez de vous désabonner en tant qu'utilisateur,
              vos vidéos, albums et emplacements seront conservés
              temporairement, au cas où vous décideriez de réutiliser notre
              application. Par conséquent, nous conserverons ce type
              d'informations pendant 90 jours. Une fois ce délai écoulé, nous
              procéderons à leur suppression, ne conservant que les données
              d'utilisateur de base à des fins historiques.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              4. Quelle est la légitimité du traitement de vos données ?
            </h2>
            <br></br>
            <p>
              Légalement, nous pouvons traiter les données que vous nous
              fournissez une fois que vous nous avez donné votre consentement
              pour le faire. Cela se produit lorsque vous consentez expressément
              à créer un profil sur beder après avoir été informé de notre
              Politique de confidentialité et de nos Conditions d'utilisation.
            </p>
            <br></br>
            <p>
              En général, pour accéder à notre application, vous devez accepter
              nos conditions de service, ainsi que d'avoir lu notre politique de
              confidentialité, nos cookies et autres textes juridiques connexes.
            </p>
            <br></br>
            <p>
              Dans le cas de l'archivage et du partage et de la publication de
              vidéos ou d'images sur les réseaux sociaux. Dans le premier
              scénario, la base de ce point réside dans l'intérêt légitime de
              BEDER à fournir un bon service aux utilisateurs et à gérer la
              relation avec eux, ainsi qu'à garantir la sécurité des
              utilisateurs. Pour le deuxième scénario, BEDER a un intérêt
              légitime à connaître davantage de membres de la communauté et à
              partager leur activité sur la base de la relation précédente
              établie par l'utilisation des hashtags d'entreprise et des
              mentions de notre profil sur les réseaux sociaux.
            </p>
            <br></br>
            <p>
              Enfin, vous nous autorisez à rendre publiques les vidéos que vous
              partagez dans notre application en les publiant expressément.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              5. Vos données sont-elles communiquées à d'autres destinataires ?
            </h2>
            <br></br>
            <p>
              Les données que vous saisissez sur le site Web ne seront pas
              communiquées à d'autres entités, sauf impératif légal ou pour
              pouvoir donner suite à la raison pour laquelle elles ont été
              fournies.
            </p>
            <br></br>
            <p>
              L'application BEDER utilise des outils tiers, qui permettent
              d'intégrer les utilitaires et les outils que vous pouvez utiliser
              :
            </p>
            <br></br>
            <ul>
              <li>
                • Connexion Apple et Google via Firebase
                <ul>
                  <li>
                    •{" "}
                    <a
                      className="text-[#00f3cd]"
                      href="https://www.apple.com/legal/"
                    >
                      https://www.apple.com/legal/
                    </a>
                  </li>
                  <br></br>
                  <li>
                    •{" "}
                    <a
                      className="text-[#00f3cd]"
                      href="https://firebase.google.com/support/privacy?hl=es-419"
                    >
                      https://firebase.google.com/support/privacy?hl=es-419
                    </a>
                  </li>
                  <br></br>
                </ul>
              </li>
              <br></br>
              <li>
                • API Google{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://developers.google.com/terms"
                >
                  https://developers.google.com/terms
                </a>
              </li>
              <br></br>
              <li>
                • Amazon Web Services (AWS){" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://aws.amazon.com/en/privacy"
                >
                  https://aws.amazon.com/en/privacy
                </a>
              </li>
              <br></br>
              <li>
                • Déploiement du serveur et du tableau de bord Heroku{" "}
                <a
                  className="text-[#00f3cd]"
                  href="https://www.heroku.com/policy/security"
                >
                  Sécurité Heroku | Heroku
                </a>
              </li>
              <br></br>
              <li>• Déploiement de l'application appcenter</li>
              <br></br>
              <li>• Base de données MYSQL</li>
              <br></br>
            </ul>
            <p>
              Dans notre application, vous pouvez activer différentes
              fonctionnalités telles que la localisation, les notifications push
              ou l'accès à votre galerie sur sélection personnelle. Les données
              collectées lors de l'activation de ces fonctions seront traitées
              de la même manière que le reste des informations collectées via
              nos formulaires.
            </p>
            <br></br>
            <p>
              Vos données peuvent être collectées via des formulaires sur notre
              site Web qui sont hébergés sur les serveurs AMAZON WEB SERVICES,
              situés aux États-Unis. Cette entreprise, bien qu'étant en dehors
              de l'Union européenne, est soumise au Bouclier de protection des
              données pour garantir la protection des informations. Vous pouvez
              consulter leur politique de confidentialité sur :{" "}
              <a
                className="text-[#00f3cd]"
                href="https://aws.amazon.com/es/privacy/"
              >
                https://aws.amazon.com/es/privacy/
              </a>
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              6. Quels sont vos droits lorsque vous nous fournissez vos
              informations ?
            </h2>
            <br></br>
            <p>
              <strong>Droit à l'information</strong>
              <br></br>Vous avez le droit d'être informé clairement AVANT la
              collecte de vos données sur quelles données sont traitées, dans
              quel but elles sont traitées, d'où elles ont été obtenues et si
              elles vont être communiquées ou ont été communiquées à quelqu'un.
            </p>
            <br></br>
            <p>
              <strong>
                <br></br>Droit d'accès
              </strong>
              <br></br>Pour savoir quelles sont vos données qui sont traitées,
              dans quel but, d'où elles ont été obtenues et si elles vont être
              communiquées ou ont été communiquées à quelqu'un.
            </p>
            <br></br>
            <p>
              <strong>Droit de rectification</strong>
              <br></br>Pour modifier vos données inexactes ou incomplètes.
            </p>
            <br></br>
            <p>
              <strong>Droit de suppression</strong>
              <br></br>pour annuler/supprimer vos données inappropriées ou
              excessives
            </p>
            <br></br>
            <p>
              <strong>Droit d'annulation</strong>
              <br></br>Pour annuler vos données inappropriées ou excessives.
            </p>
            <br></br>
            <p>&nbsp;</p>
            <br></br>
            <p>
              <strong>Droit d'opposition</strong>
            </p>
            <br></br>
            <p>
              Pour empêcher que vos données ne soient traitées ou pour cesser
              d'être traitées, uniquement dans les cas établis par la loi.
            </p>
            <br></br>
            <p>
              <strong>Droit de limitation du traitement</strong>
            </p>
            <br></br>
            <p>
              Demander de ne pas utiliser le traitement des données dans les cas
              établis par la loi.
            </p>
            <br></br>
            <p>&nbsp;</p>
            <br></br>
            <p>
              <strong>Droit à la portabilité des données</strong>
            </p>
            <br></br>
            <p>
              Pouvoir recevoir vos données fournies dans un format électronique
              structuré pour une utilisation normale et afin de pouvoir les
              transmettre à la personne responsable.
            </p>
            <br></br>
            <p>&nbsp;</p>
            <br></br>
            <p>
              <strong>
                Droit de ne pas être l'objet de décisions individualisées
              </strong>
            </p>
            <br></br>
            <p>
              Afin de ne pas prendre une décision vous concernant qui produit
              des effets juridiques ou vous affecte uniquement sur la base du
              traitement de vos données.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              7. Comment pouvez-vous exercer vos droits ?
            </h2>
            <br></br>
            <p>
              Pour exercer l'un de vos droits, vous devez en faire la demande
              par courrier électronique à{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>{" "}
              en incluant :
            </p>
            <br></br>
            <p>
              1.- Photocopie du numéro d'identification (passeport ou autre
              document d'identité) ou signature électronique.
            </p>
            <br></br>
            <p>
              2.- Contenu de la demande que vous faites et, si nécessaire, les
              documents qui le prouvent.
            </p>
            <br></br>
            <p>3.- Adresse (à des fins de notification), date et signature</p>
            <br></br>
            <p>
              Si vous exercez vos droits par l'intermédiaire d'un représentant
              volontairement désigné, vous devez fournir le document ou
              l'instrument électronique prouvant la représentation.
            </p>
            <br></br>
            <p>
              Dans le cas où le propriétaire des données est mineur ou
              handicapé, les droits seront exercés par leur représentant légal
              dûment accrédité.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              8. Que pouvez-vous faire si vos droits n'ont pas été pris en
              compte ?
            </h2>
            <br></br>
            <p>
              Dans le cas où vous estimez que nous n'avons pas satisfait à votre
              demande, vous pouvez déposer une réclamation auprès de l'Agence
              espagnole de protection des données dans la section de son site
              Web :
              <a
                className="text-[#00f3cd]"
                href="https://sedeagpd.gob.es/sede-electronica-web/vistas/formReclamacionDerechos"
              >
                https://sedeagpd.gob.es/sede-electronica-web/vistas/formReclamacionDerechos
              </a>{" "}
              /reclamation.Rights.jsf
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              9. Liens vers d'autres sites Web
            </h2>
            <br></br>
            <p>
              Cette politique de confidentialité ne s'applique qu'aux données
              personnelles collectées via notre site Web, mais ce site Web
              contient des liens vers d'autres sites Web, donc le Centre n'est
              pas responsable des pratiques de confidentialité de ces autres
              sites Web.
            </p>
            <br></br>
            <p>
              Autrement dit, lorsque vous cliquez sur un de ces liens, vous
              quittez notre site Web, donc vous devriez lire les politiques de
              confidentialité de ces autres sites Web qui collectent des données
              personnelles.
            </p>
            <br></br>
            <p>
              Si vous souhaitez plus d'informations, l'Agence espagnole de
              protection des données a publié un guide du citoyen, vous pouvez y
              accéder à l'adresse :
            </p>
            <br></br>
            <p>
              <a
                className="text-[#00f3cd]"
                href="http://www.agpd.es/portalwebAGPD/canaldocumentacion/publicaciones/common/Guias/GUIA_CIUDADANO.pdf"
              >
                http://www.agpd.es/portalwebAGPD/canaldocumentacion/publications/common/Guias/GUIA_CIUDADANO.pdf
              </a>
              &nbsp;
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              10. Confidentialité des enfants
            </h2>
            <br></br>
            <p>
              Ces Services ne s'adressent pas aux personnes de moins de 14 ans.
              Nous ne collectons pas sciemment d'informations personnelles
              auprès d'enfants de moins de 14 ans. Dans le cas où nous
              découvrions qu'un enfant de moins de 14 ans nous a fourni des
              informations personnelles, nous les supprimerions immédiatement de
              nos serveurs. Si vous êtes un parent ou un tuteur et que vous
              savez que votre enfant nous a fourni des informations
              personnelles, veuillez nous contacter afin que nous puissions
              prendre les mesures nécessaires.
            </p>
            <br></br>
            <br></br>
            <h2 className="text-[23px] font-bold">
              11. Pour les utilisateurs californiens
            </h2>
            <br></br>
            <p>
              La California Consumer Privacy Act (CCPA) nous oblige à divulguer
              les catégories d'informations personnelles que nous collectons et
              comment nous les utilisons, les catégories de sources à partir
              desquelles nous collectons des informations personnelles, et les
              tiers avec qui nous les partageons. Nous avons divulgué ces
              informations tout au long de ce document dans les sections 2 et
              ci-dessous.
            </p>
            <br></br>
            <p>
              Nous devons également communiquer des informations sur les droits
              dont disposent les résidents de Californie en vertu de la loi
              californienne. Vous pouvez exercer les droits suivants :
            </p>
            <br></br>
            <ul>
              <li>
                • Droit à l'information et à l'accès. Vous pouvez soumettre une
                demande vérifiable d'information sur :
              </li>
              <br></br>
            </ul>
            <ol>
              <li>
                • les catégories d'informations personnelles que nous
                collectons, utilisons ou partageons ;
              </li>
              <br></br>
            </ol>
            <ul>
              <li>
                <ol>
                  <li>
                    • les objectifs pour lesquels nous collectons ou utilisons
                    les informations personnelles ;
                  </li>
                  <br></br>
                </ol>
              </li>
              <li>
                <ol>
                  <li>
                    • les catégories de tiers avec lesquels nous partageons des
                    informations personnelles ; et
                  </li>
                  <br></br>
                </ol>
              </li>
              <li>
                <ol>
                  <li>
                    • les informations spécifiques que nous avons collectées sur
                    vous au cours des 12 derniers mois.
                  </li>
                  <br></br>
                </ol>
              </li>
            </ul>
            <p>
              Veuillez noter que nous ne pouvons pas répondre à votre demande ou
              vous fournir d'informations personnelles si nous ne pouvons pas
              vérifier votre identité ou votre autorité à faire la demande et
              confirmer que les informations personnelles vous concernant dans
              nos dossiers. Faire une demande d'information ou d'accès aux
              informations personnelles peut exiger que nous vérifions votre
              identité pour assurer que nous ne donnons pas des informations
              personnelles à une personne qui n'a pas le droit de les recevoir.
            </p>
            <br></br>
            <ul>
              <li>
                • Droit à l'effacement (également connu sous le nom de droit à
                l'oubli). Vous avez le droit de demander que nous supprimions
                les informations personnelles que nous avons collectées sur
                vous, sous réserve d'exceptions.
              </li>
              <br></br>
            </ul>
            <p>
              Veuillez noter que votre demande ne garantit pas l'effacement
              complet ou complet de vos données personnelles. Il est possible
              que des exceptions s'appliquent à votre demande.
            </p>
            <br></br>
            <ul>
              <li>
                • Droit à l'opt-out. Vous avez le droit de demander que nous ne
                vendions pas vos informations personnelles à des tiers. Vous
                pouvez soumettre une demande de retrait de la vente de vos
                informations personnelles à tout moment.
              </li>
              <br></br>
            </ul>
            <p>
              Nous vous remercions de l'intérêt que vous portez à BEDER et à
              notre politique de confidentialité. Pour toute question, vous
              pouvez nous contacter par courrier électronique à{" "}
              <a className="text-[#00f3cd]" href="mailto:info@beder.app">
                info@beder.app
              </a>
              . Merci de faire partie de notre communauté BEDER !
            </p>
          </div>
        )}
        <div className="bg-white  mb-20  w-[90%] "></div>
      </section>
      <section>
        <div className="bg-white  -mb-20 "></div>
      </section>
    </MainLayout>
  );
}
